import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/fishing-animation.webm';
import _imports_1 from '@/assets/icons/kizuna-logo.svg';
const _hoisted_1 = {
  class: "loading-mask-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "fishing-container"
}, [/*#__PURE__*/_createElementVNode("video", {
  class: "fishing",
  muted: "",
  autoplay: "autoplay",
  loop: "loop",
  rel: "preload",
  fetchpriority: "high"
}, [/*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "video/webm"
})])], -1);
const _hoisted_3 = {
  class: "logo-container"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_1,
  alt: "Kizuna"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _ctx.showProgress ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["logo-mask", {
      s90: _ctx.remainingAssetsProgress >= 90,
      s80: _ctx.remainingAssetsProgress >= 80,
      s70: _ctx.remainingAssetsProgress >= 70,
      s60: _ctx.remainingAssetsProgress >= 60,
      s50: _ctx.remainingAssetsProgress >= 50,
      s40: _ctx.remainingAssetsProgress >= 40,
      s30: _ctx.remainingAssetsProgress >= 30,
      s20: _ctx.remainingAssetsProgress >= 20,
      s10: _ctx.remainingAssetsProgress >= 10,
      s0: _ctx.remainingAssetsProgress >= 0
    }])
  }, null, 2)) : _createCommentVNode("", true)])]);
}